var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9818 11.8418C14.4386 12.3835 13.5594 12.3835 13.0162 11.8418L2.24833 1.07291C2.09965 0.924206 2.04758 0.704305 2.1138 0.504705C2.23388 0.138905 2.57631 0.105606 2.88206 0.105606H25.1182C25.4228 0.105606 25.763 0.138905 25.8853 0.504705C25.9515 0.704305 25.8995 0.924206 25.7508 1.07291L14.9818 11.8418ZM26.9949 2.18581C27.0532 2.12731 27.1412 2.11011 27.2173 2.14241C27.2929 2.17361 27.3421 2.24741 27.3418 2.32921V15.6709C27.3418 16.8989 26.3462 17.8945 25.1182 17.8945H2.88206C1.65399 17.8945 0.658449 16.8989 0.658449 15.6709V2.32921C0.658069 2.24801 0.706209 2.17451 0.780749 2.14241C0.856699 2.10951 0.945089 2.12671 1.00311 2.18581L11.8354 13.0203C13.0293 14.2135 14.9643 14.2135 16.1581 13.0203L26.9949 2.18581Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.9a82653d.svg";
export { ForwardRef as ReactComponent };